/**
 * PostHog EU constants shared by the browser client, the Nitro reverse proxy
 * (`vite.config.ts`) and Convex server-side capture. Pure values only (no
 * `import.meta.env`), so every runtime can import this file.
 *
 * EU ONLY, ALWAYS: never put a US PostHog host anywhere in this project.
 */

/** Public project API key of PostHog project "Agentic School" (id 328542). Public by design. */
export const POSTHOG_PUBLIC_KEY = 'phc_sJsMBK8DQuh6Fhb9C3Az356dULnsG2dK6X8oV9tAjT6Q'

/** PostHog project id (for links in docs and CI sourcemap uploads). */
export const POSTHOG_PROJECT_ID = 328542

/**
 * Release name for error tracking (source maps). Release = `agentic-school@<git
 * sha>`; the browser sends the sha as `app_release` (see vite.config.ts).
 */
export const ANALYTICS_RELEASE_NAME = 'agentic-school'

/** PostHog EU app (UI, API, toolbar links). */
export const POSTHOG_UI_HOST = 'https://eu.posthog.com'

/** PostHog EU event ingestion origin (proxied at {@link POSTHOG_PROXY_PATH}). */
export const POSTHOG_INGEST_ORIGIN = 'https://eu.i.posthog.com'

/** PostHog EU static assets origin (SDK extensions, remote config). */
export const POSTHOG_ASSETS_ORIGIN = 'https://eu-assets.i.posthog.com'

/**
 * Same-origin reverse proxy path. The browser only ever talks to
 * `https://agenticschool.dev/ingest/*`, so ad blockers that block
 * `*.posthog.com` do not drop events, and no third-party origin is contacted.
 */
export const POSTHOG_PROXY_PATH = '/ingest'

/** Server-side single-event capture endpoint (Convex). */
export const POSTHOG_CAPTURE_URL = `${POSTHOG_INGEST_ORIGIN}/i/v0/e/`

/** Hostnames that send analytics by default. Everything else is dev/test. */
export const ANALYTICS_PRODUCTION_HOSTS: ReadonlyArray<string> = [
  'agenticschool.dev',
  'www.agenticschool.dev',
]

/**
 * Opt-in switch for non-production hosts (local debugging, e2e): either the
 * `?ph_debug=1` query parameter (this page load only) or this cookie. Events
 * sent in debug mode carry `environment: 'debug'`, which the project's
 * test-account filter excludes.
 */
export const POSTHOG_DEBUG_COOKIE = 'ae_ph_debug'
export const POSTHOG_DEBUG_QUERY = 'ph_debug'

/** posthog-js config defaults snapshot (see `defaults` in the SDK docs). */
export const POSTHOG_CONFIG_DEFAULTS = '2026-05-30' as const

/** Session replay text masking: elements matching this are always masked. */
export const POSTHOG_MASK_TEXT_SELECTOR = '[data-ph-mask], .ph-mask'
